import Glob from "./Glob.mjs";

/**
 * @private
 * @type {true|undefined}
 */
let setupDone;

/**
 * Setup, performed only once
 * @return {Promise<boolean>}
 */
export const appBootstrapSetup = () => {
	return new Promise((resolve) => {
		if ( setupDone ) return resolve(setupDone);
		//const u = window.location.pathname.slice(1).replace(/[#/].*$/,'');
		Glob.setupApp({
			homePage: 'MainMenu',
			appRootNode: 'horus-app-root-node',
			keyApplicationName: 'horus-frontend',
			uri : {
				onlinebackend : '/backend/',
				offlinebackend : 'https://horus-dev.phb.ovh/backend/',
				//offlinebackend : 'http://localhost:3002/backend/',
			}
		});
		resolve(setupDone = true);
	});
}

if ( ! setupDone ) setTimeout( appBootstrapSetup );

export default appBootstrapSetup;
